// extracted by mini-css-extract-plugin
export var checkbox = "_8z-0";
export var circle = "_8z-3";
export var horizontalContainer = "_8z-7";
export var sm = "_8z-5";
export var switch0 = "_8z-2";
export var switchDisabled = "_8z-8";
export var switchEnabled = "_8z-1";
export var textSwitchContainer = "_8z-9";
export var textSwitchOption = "_8z-a";
export var textSwitchOptionSelected = "_8z-b";
export var verticalContainer = "_8z-6";
export var xs = "_8z-4";